export enum JobsCardTab {
  MeterActivation = 'meterActivation',
  MeterDeactivation = 'meterDeactivation',
  PDFPasport = 'pdfPasport',
  ParseDocuments = 'parseDocuments',
  ProcessInvoices = 'processInvoices',
}
